import { HttpContextToken } from '@angular/common/http';

/** Resolved from the widget's inputs at call time; see `CreateEntityElementComponent.$config`. */
export interface CreateEntityWidgetConfig {
    /** Sent as `Authorization: Bearer <accessToken>` on every call. Held in memory only. */
    accessToken: string;
    /** Requests go to `${jemmaBaseUrl}/api/v1/secure/...`. */
    jemmaBaseUrl: string;
    /** Sent as `jemma-event-source`, which Jemma records in its audit log against each call. Supplied by the host — the widget has no ID of its own. */
    eventSource: string;
}

/**
 * Carries the calling widget instance's config on each outgoing `HttpRequest`
 * so the single app-wide `createEntityAuthInterceptor` can attach the right token
 * per call. A page can hold more than one `<wcg-create-entity>` instance with
 * different tokens, and a functional interceptor's `inject()` resolves against
 * the root injector rather than the calling component's, so component-scoped
 * config can't reach it that way. `HttpContext` is the supported way to pass
 * per-call data into a shared interceptor.
 */
export const CREATE_ENTITY_REQUEST_CONFIG = new HttpContextToken<CreateEntityWidgetConfig | null>(() => null);
